import React, {useEffect} from "react"
// import ExcelExport from 'export-xlsx'
// import { SETTINGS_FOR_EXPORT } from "./setting-for-export"

export const ExportExcel = ({contractors}) => {

    const gtm_tracking = () => {

        // Get all Service Tag Elements
        let facSearchServiceTagElements = document.getElementsByClassName('fac-tag-select-content');

        // Loop through all Service Tag Elements and their text to 'facSearchServiceTags'
        let facSearchServiceTags = ''
        for (let i = 0; i < facSearchServiceTagElements.length; i++) {

            const element = facSearchServiceTagElements[i];

            // Add a comma if its not the first element
            if(i == 0) {
                facSearchServiceTags += element.textContent;
            } else {
                facSearchServiceTags += ", " + element.textContent;
            }

        }

        // Get the search location
        let facSearchLocation = document.querySelector('.fac-input-location-field').value;

        // Add the data to the Datalayer object from Google Tag Manager
        window.dataLayer.push({
            "event": "fac-export-results",
            "fac-services": facSearchServiceTags,
            "fac-project-location": facSearchLocation
        });

    };

    // export excel
    useEffect(() => {
        const data = [
            contractors.map( (c) => {
                const contractorSpecialty = String([c.ppn_primary_specialty, c.ppn_secondary_specialty, c.ppn_tertiary_specialty, c.ppn_quaternary_specialty].filter(n=>n))
                return (
                    [
                        c.company_name,
                        c.number_completed_projects,
                        contractorSpecialty,
                        c.address1_city,
                        c.address1_state,
                        c.address1_zip,
                        c.main_phone
                    ]
                )
            })
        ]
        document.getElementById('render-find-a-contractor').dataset.contractors = JSON.stringify(data)
      }, [contractors]);

    return (
        <>
            <button className="fac-export-btn" onClick={() => {
                const downloadTrigger = document.querySelector('.export-excel-button')
                if (downloadTrigger) {
                    downloadTrigger.click();
                } else {
                    console.log('test');
                }
                gtm_tracking()
            }}>
                export
            </button>
        </>
    )

}